import { render, staticRenderFns } from "./ListGroupItem.vue?vue&type=template&id=30f46736&"
import script from "./ListGroupItem.vue?vue&type=script&lang=js&"
export * from "./ListGroupItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports